// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"b000a0e8","95":"ee6e3cfe","183":"ef23adf6","952":"cf235397"}[chunkId] + ".chunk.css";
};